// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ETk_","label":"Completed_label__Q2nz9"};